{
  "toast": {
    "companyCreated": "Company créé",
    "storeCreated": "Store créé",
    "warehouseCreated": "Warehouse créé",
    "workCalendarConfigured": "Work calendar configurerd",
    "departmentCreated": "Department créé",
    "enterpriseSetupComplete": "Enterprise configuration complete",
    "onboardingCompleted": "Onboarding terminé",
    "productCreated": "Product créé",
    "customerCreated": "Customer créé",
    "productsSaved": "Products enregistré"
  },
  "errors": {
    "createOrSelectAWeekPattern": "Create ou sélectionner a week pattern",
    "failedToCreateCompany": "Échec de la création de company",
    "failedToCreateStore": "Échec de la création de store",
    "failedToCreateWarehouse": "Échec de la création de warehouse",
    "failedToLoadWeekPatterns": "Échec du chargement de week patterns",
    "failedToSaveCalendar": "Échec de l'enregistrement de calendar",
    "failedToCreateDepartment": "Échec de la création de department",
    "unableToCompleteOnboardingPleaseReviewDetailsAnd": "Impossible de terminer l'intégration. Veuillez vérifier les informations et réessayer.",
    "storeNameAndCodeAreRequired": "Magasin name et code are requis",
    "productNameIsRequired": "Produit name is requis",
    "customerNameIsRequired": "Client name is requis",
    "failedToCreateProduct": "Échec de la création de product",
    "failedToCreateCustomer": "Échec de la création de customer",
    "selectAtLeastOneProductToContinue": "Sélectionnez au moins un product to continue",
    "couldNotSaveYourProductSelectionPleaseTry": "Impossible de save your product selection. Please try again."
  },
  "pages": {
    "enterpriseSetup": "Enterprise configuration",
    "organizationCompanyStoreWarehouseCalendarHr": "Organization → Company → Magasin → Entrepôt → Calendar → HR → Finance → Go Live",
    "setUpPointOfSale": "Set up Point of Sale",
    "completeTheseStepsToStartSelling": "Complete these steps à start selling"
  },
  "labels": {
    "companyName": "Entreprise name",
    "code": "Code",
    "storeName": "Magasin name",
    "storeCode": "Magasin code",
    "warehouseName": "Entrepôt name",
    "warehouseCode": "Entrepôt code",
    "assignWeekPattern": "Assign week pattern",
    "departmentName": "Département name",
    "departmentCode": "Département code",
    "organizationName": "Organization name",
    "organizationType": "Organization type",
    "industry": "Industry",
    "logoUrl": "Logo URL",
    "themeMode": "Theme mode",
    "productName": "Produit name",
    "sku": "SKU",
    "price": "Prix",
    "customerName": "Client name",
    "phone": "Téléphone"
  },
  "defaults": {
    "organizationType": "Société"
  },
  "plans": {
    "FREE": {
      "title": "Gratuit",
      "details": "Utilisation limitée avec invitations à mettre à niveau"
    },
    "STARTER": {
      "title": "Starter",
      "details": "Utilisation en production pour petites équipes"
    },
    "PROFESSIONAL": {
      "title": "Professionnel",
      "details": "Organisations en croissance et automatisation"
    },
    "ENTERPRISE": {
      "title": "Entreprise",
      "details": "Contrôles avancés et options de marque blanche"
    },
    "CUSTOM": {
      "title": "Personnalisé",
      "details": "Limites adaptées et plan sur mesure"
    }
  },
  "theme": {
    "light": "Clair",
    "dark": "Sombre"
  },
  "placeholders": {
    "logoUrl": "https://..."
  },
  "productSelection": {
    "continueSetup": "Continuer la configuration",
    "description": "Choisissez une ou plusieurs applications pour votre organisation. Vous pourrez en activer d'autres plus tard depuis les paramètres.",
    "modules": {
      "CRM": {
        "description": "Prospects, opportunités et cycle de vie client"
      },
      "DESK": {
        "description": "Support et workflows de tickets"
      },
      "FINANCE": {
        "description": "Comptabilité et reporting"
      },
      "HR": {
        "description": "Employés, présence et paie"
      },
      "POS": {
        "description": "Facturation, reçus et encaissement"
      },
      "PROJECTS": {
        "description": "Tâches, sprints et livraison"
      },
      "SOCIAL": {
        "description": "Publication et gestion de la boîte de réception"
      }
    },
    "saving": "Enregistrement…",
    "title": "Choisir les produits",
    "welcome": "Bienvenue — choisissez les produits dont vous avez besoin",
    "welcomeNamed": "Bienvenue, {{name}} — choisissez les produits dont vous avez besoin"
  },
  "wizard": {
    "actions": {
      "back": "Retour",
      "continue": "Continuer",
      "finishOnboarding": "Terminer l'onboarding",
      "finishing": "Finalisation..."
    },
    "eyebrow": "Onboarding Fattah",
    "guidedQuickTour": "Visite guidée rapide",
    "stepSummary": "Étape {{step}} sur {{totalSteps}} — détails de l'organisation, plan, marque et configuration guidée.",
    "title": "Configurez l'espace de travail de votre organisation",
    "tours": {
      "crm": "CRM : créer un prospect → avancer le pipeline → convertir l'opportunité",
      "hr": "RH : créer un employé → configurer la présence → lancer la paie",
      "pos": "PDV : créer un produit → créer un client → générer une facture"
    },
    "whiteLabelEnterpriseOnly": "La marque blanche est disponible avec les plans Entreprise et Personnalisé."
  },
  "listActions": {
    "openPosTerminal": "Ouvrir le terminal PDV"
  }
}
